import Vue from 'vue';
import apiClient from '../../apiClient';

const state = {
  access_token: localStorage.getItem('access_token') || '',
  status: '',
  isLoggedIn: !!localStorage.getItem('access_token')
};

const getters = {
  isLoggedIn: state => state.isLoggedIn
};

const actions = {
  login: ({ commit, dispatch, rootState }, data) =>
    new Promise((resolve, reject) => {
      commit('startLoad');
      apiClient
        .post('/auth/login', data)
        .then(resp => {
          const { access_token: token } = resp.data;

          localStorage.setItem('access_token', token);
          apiClient.defaultConfig.headers.Authorization = `Bearer ${token}`;

          commit('endLoad');
          commit('login', token);

          dispatch('userRequest')
            .then(() => {
              const { id: userId } = rootState.user.profile;

              Promise.all([
                dispatch('setConnectionWithSocket', userId),
                dispatch('getUserBalance', userId),
                dispatch('getNotifications')
              ]).then(() => {
                resolve(resp);
              });
            })
            .catch(err => {
              dispatch('disableConnectionWithSocket');
              localStorage.removeItem('access_token');
              reject(err);
            });
        })
        .catch(err => {
          dispatch('disableConnectionWithSocket');
          commit('endLoad');
          localStorage.removeItem('access_token');
          reject(err);
        });
    }),

  logout: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      apiClient
        .post('/auth/logout')
        .then(resp => {
          dispatch('disableConnectionWithSocket');
          commit('logout');
          localStorage.removeItem('access_token');
          delete apiClient.defaultConfig.headers.Authorization;
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  register: ({ commit, dispatch, rootState }, data) =>
    new Promise((resolve, reject) => {
      apiClient
        .post('auth/signup', data)
        .then(resp => {
          const { access_token: token } = resp.data;

          localStorage.setItem('access_token', token);
          apiClient.defaultConfig.headers.Authorization = `Bearer ${token}`;

          commit('endLoad');
          commit('login', token);

          dispatch('userRequest')
            .then(() => {
              const { id: userId } = rootState.user.profile;

              Promise.all([
                dispatch('setConnectionWithSocket', userId),
                dispatch('getUserBalance', userId),
                dispatch('getNotifications')
              ]).then(() => {
                resolve(resp);
              });
            })
            .catch(err => {
              dispatch('disableConnectionWithSocket');
              localStorage.removeItem('access_token');
              reject(err);
            });
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    })
};

const mutations = {
  login(state, token) {
    Vue.set(state, 'isLoggedIn', true);
    Vue.set(state, 'status', 'success');
    Vue.set(state, 'access_token', token);
  },

  logout(state) {
    Vue.set(state, 'isLoggedIn', false);
    Vue.set(state, 'status', 'error');
    Vue.set(state, 'access_token', null);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
